import { ContentLimiter } from 'components/atoms';
import React from 'react';
import { Insolvenz, InsolvenzBeschluss } from 'types';
import { useTranslation } from 'utils/hooks';

import css from './Insolvenz.module.scss';

type GroupedInsolvenz = {
  [key: string]: {
    bekanntmachungsDatum: string;
    beschlussDatum: string;
    beschlüsse: InsolvenzBeschluss[];
  };
};

interface InsolvenzUIProps
{
  insolvenz: Insolvenz;
}

const InsolvenzUI: React.FC<InsolvenzUIProps> = (props) =>
{
  const { insolvenz } = props;
  const { t } = useTranslation(['profiles', 'formats']);

  const grouped = insolvenz.beschlüsse.reduce((acc: GroupedInsolvenz, beschluss) => 
  {
    const groupKey = `${beschluss.beschlussDatum}-${beschluss.bekanntmachungsDatum}`;
    
    if (!acc[groupKey]) 
    {
      acc[groupKey] = {
        bekanntmachungsDatum: beschluss.bekanntmachungsDatum,
        beschlussDatum: beschluss.beschlussDatum,
        beschlüsse: [],
      };
    }

    acc[groupKey].beschlüsse.push(beschluss);

    return acc;

  }, {});

  const insolvenzen = Object.entries(grouped).sort(([aKey], [bKey]) => bKey.localeCompare(aKey));

  return (
    <li>
      <h4 className={css.verfahrensart}>{ t(`profiles:unternehmen.insolvenz.verfahrensart.${insolvenz.verfahrensart}`) }</h4>

      <div className={css.meta}>{t('profiles:unternehmen.insolvenz.source')}</div>
      <div className={css.meta}>{t('profiles:unternehmen.insolvenz.aktenzeichen', { value: insolvenz.aktenzeichen })}</div>
      <div className={css.meta}>{t('profiles:unternehmen.insolvenz.gericht', { value: insolvenz.gericht })}</div>

      {/* Beschlüsse */}
      <ContentLimiter stepSize={3} initialLimit={1}>
        { insolvenzen.map(([key, groupedInsolvenz]) => (
          <table className={css.baustein} key={key}>
            <tbody>

              <tr>
                <th>{t('profiles:unternehmen.insolvenz.bekanntmachungsDatum.label')}</th>
                <td>{t('formats:date', { value: groupedInsolvenz.bekanntmachungsDatum })}</td>
              </tr>
              
              <tr>
                <th>{t('profiles:unternehmen.insolvenz.beschlussDatum.label')}</th>
                <td>{t('formats:date', { value: groupedInsolvenz.beschlussDatum })}</td>
              </tr>

              {groupedInsolvenz.beschlüsse.map((beschluss, index) => (
                <tr key={`beschluss-${beschluss.titel}-${index}`}>
                  <th>{ beschluss.titel }</th>
                  <td>{ beschluss.text }</td>
                </tr>
              ))}
            </tbody>
          </table>
        ))}
      </ContentLimiter>

    </li>
  );
};

export default InsolvenzUI;
